<script setup lang="ts">
import { ConfirmationPopup } from '@metapic-apps/shared'

import { useDeleteCampaignRequest } from '@/api'
import { notification } from '@/lib/helpers'

const props = defineProps<{ campaignId?: number }>()
const emits = defineEmits(['onDelete'])
const isOpen = defineModel<boolean>('modelValue', { default: false })
const { deleteCampaign: deleteCampaignRequest, isLoading: isDeletingLoading, error: isDeleteError } = useDeleteCampaignRequest()

const deleteCampaign = async () => {
  if (!props.campaignId) {
    return
  }
  await deleteCampaignRequest(props.campaignId)
  isOpen.value = false
  if (!isDeleteError.value) {
    notification.success('The campaign was deleted successfully')
  }
  emits('onDelete')
}
</script>
<template>
  <ConfirmationPopup
    v-model="isOpen"
    :is-loading="isDeletingLoading"
    title="Delete campaign"
    description="Are you sure you want to delete this campaign? Deleting this campaign will remove access for all applied creators."
    @on-submit="deleteCampaign"
  />
</template>
